import { Modal } from "@telluscompany/design-system";

import { useLocalization } from "@i18n";

import type { InspectionListItem } from "../../api/inspection";
import InspectionCreateForm from "./InspectionCreateForm";
import "../../styles/inspection-ui.css";

export interface InspectionCreateModalProps {
  isOpen: boolean;
  onClose: () => void;
  structureId: string;
  onCreated: (created: InspectionListItem) => void;
}

/**
 * Modal de Nova inspeção (form §7.2 / Y=4): só cabeçalho. Sem registry,
 * sem `templateVersion` — o back carimba a versão na criação.
 */
const InspectionCreateModal = ({
  isOpen,
  onClose,
  structureId,
  onCreated,
}: InspectionCreateModalProps) => {
  const { translate } = useLocalization();

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      title={translate("inspection.actions.new")}
      width="560px"
      content={
        <InspectionCreateForm
          structureId={structureId}
          onCancel={onClose}
          onCreated={onCreated}
        />
      }
    />
  );
};

export default InspectionCreateModal;
